module.exports = __webpack_public_path__ + "images/bullet_right_blue.png";